var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Setting",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.246,
    height: 18.158,
    viewBox: "0 0 17.246 18.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Setting-2",
    "data-name": "Setting",
    d: "M9.256,18.158H7.994A1.876,1.876,0,0,1,6.065,16.3a1.729,1.729,0,0,0-1.708-1.652,1.435,1.435,0,0,0-.816.209,1.964,1.964,0,0,1-.984.272,1.926,1.926,0,0,1-1.651-.944l-.64-1.09A1.819,1.819,0,0,1,.247,11.23a1.914,1.914,0,0,1,.742-.717,1.5,1.5,0,0,0,.585-.581,1.618,1.618,0,0,0,.172-1.239A1.668,1.668,0,0,0,.971,7.663a1.857,1.857,0,0,1-.687-2.57L.905,4.022a1.927,1.927,0,0,1,2.616-.69,1.72,1.72,0,0,0,.814.2,1.779,1.779,0,0,0,1.514-.83,1.4,1.4,0,0,0,.214-.8,1.624,1.624,0,0,1,.26-.962A2,2,0,0,1,7.966,0H9.274a1.955,1.955,0,0,1,1.652.945,1.617,1.617,0,0,1,.25.962,1.4,1.4,0,0,0,.213.8,1.783,1.783,0,0,0,1.518.83,1.748,1.748,0,0,0,.82-.2,1.916,1.916,0,0,1,2.607.69l.621,1.071a1.84,1.84,0,0,1-.686,2.57A1.661,1.661,0,0,0,15.5,8.7a1.608,1.608,0,0,0,.181,1.237,1.426,1.426,0,0,0,.575.581A2.094,2.094,0,0,1,17,11.23a1.844,1.844,0,0,1-.018,1.861l-.65,1.09a1.905,1.905,0,0,1-2.626.672,1.472,1.472,0,0,0-.816-.209A1.724,1.724,0,0,0,11.176,16.3,1.871,1.871,0,0,1,9.256,18.158ZM8.634,6.519A2.606,2.606,0,0,0,6,9.088,2.509,2.509,0,0,0,6.771,10.9a2.66,2.66,0,0,0,1.864.746,2.562,2.562,0,0,0,1.85-4.38A2.612,2.612,0,0,0,8.634,6.519Z",
    transform: "translate(0 0)",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.835c4066ffe2464472930424745ea8e2.svg";
export { ForwardRef as ReactComponent };